<template>
  <div>
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab v-for="item in items" :key="item.tab">
        {{ item.tab }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in items" :key="item.tab">
        <v-data-table
          v-if="item.tab === 'รายการตรวจสอบสต็อก'"
          ref="tableStoreDetail"
          show-expand
          :single-expand="singleExpand"
          :headers="headers"
          :items="currentStock"
          :items-per-page="20"
          :footer-props="footerProps"
          :expanded.sync="expanded"
          item-key="sku"
          class="elevation-1"
          @click:row="handleClick"
        >
          <template v-slot:item="{ item, expand, isExpanded, index }">
            <tr
              :class="{ 'bg-row-even': index % 2 === 0 }"
              @click="handleClick(item)"
            >
              <td>
                <template v-if="item.serial_list.length > 0">
                  <v-icon
                    v-if="isExpanded"
                    @click.stop="expand(!isExpanded)"
                  >
                    mdi-chevron-up
                  </v-icon>
                  <v-icon v-else @click.stop="expand(!isExpanded)">
                    mdi-chevron-down
                  </v-icon>
                </template>
              </td>
              <td class="text-left">{{ item.sku }}</td>
              <td class="text-left">{{ item.name }}</td>
              <td class="text-left">{{ item.product_brand }}</td>
              <td class="text-left">{{ item.category }}</td>
              <td class="text-left">{{ item.sub_cat }}</td>
              <td class="text-right">{{ item.amount }}</td>
              <td class="text-right">{{ item.amount_checked }}</td>
              <td>
                <div class="flex-center">
                  <v-chip
                    class="ma-2 v-chip-width"
                    :color="item.status.color"
                  >
                    <span class="text-white">
                      {{ item.status.text }}
                    </span>
                  </v-chip>
                  {{ item.description_type }}
                </div>
              </td>
              <td>
                <div class="flex-center justify-space-around">
                  <span
                    v-if="item.image_url"
                    @click.stop="openImage(item.image_url)"
                    class="px-1"
                  >
                    <div class="py-1">
                      <v-img
                        class="image-cover"
                        width="50px"
                        height="50px"
                        :src="item.image_url"
                        alt=""
                      ></v-img>
                    </div>
                  </span>
                  <span
                    v-if="item.image_url2"
                    @click.stop="openImage(item.image_url2)"
                    class="px-1"
                  >
                    <div class="py-1">
                      <v-img
                        class="image-cover"
                        width="50px"
                        height="50px"
                        :src="item.image_url2"
                        alt=""
                      ></v-img>
                    </div>
                  </span>
                  <span
                    v-if="item.image_url3"
                    @click.stop="openImage(item.image_url3)"
                    class="px-1"
                  >
                    <div class="py-1">
                      <v-img
                        class="image-cover"
                        width="50px"
                        height="50px"
                        :src="item.image_url3"
                        alt=""
                      ></v-img>
                    </div>
                  </span>
                </div>
              </td>
              <td class="text-left">{{ item.check_by }}</td>
              <td class="text-left">{{ item.updated_timestamp }}</td>
              <td class="text-left">{{ item.stock_in }}</td>
            </tr>
          </template>
          <template
            v-slot:item.data-table-expand="{
              item,
              expand,
              isExpanded,
            }"
          >
            <template v-if="item.serial_list.length > 0">
              <v-icon
                v-if="isExpanded"
                @click.stop="expand(!isExpanded)"
              >
                mdi-chevron-up
              </v-icon>
              <v-icon v-else @click.stop="expand(!isExpanded)">
                mdi-chevron-down
              </v-icon>
            </template>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <!-- serial list -->
            <template v-if="item.serial_list.length > 0">
              <tr>
                <td :colspan="headers.length">
                  <TableSerialList :data="item.serial_list" />
                </td>
              </tr>
            </template>
          </template>
        </v-data-table>

        <v-data-table
          v-else-if="item.tab === 'รายการสินค้าสต็อกเกิน'"
          ref="tableStoreDetailOverStock"
          :headers="headersOverStock"
          :items="overStock"
          :items-per-page="20"
          :footer-props="footerProps"
          item-key="product"
          class="elevation-1"
        >
          <template v-slot:item.image_url="{ item }">
            <div class="flex-center justify-space-around">
              <span
                v-if="item.image_url"
                @click.stop="openImage(item.image_url)"
                class="px-1"
              >
                <div class="py-1">
                  <v-img
                    class="image-cover"
                    width="50px"
                    height="50px"
                    :src="item.image_url"
                    alt=""
                  ></v-img>
                </div>
              </span>

              <span
                v-if="item.image_url2"
                @click.stop="openImage(item.image_url2)"
                class="px-1"
              >
                <div class="py-1">
                  <v-img
                    class="image-cover"
                    width="50px"
                    height="50px"
                    :src="item.image_url2"
                    alt=""
                  ></v-img>
                </div>
              </span>

              <span
                v-if="item.image_url3"
                @click.stop="openImage(item.image_url3)"
                class="px-1"
              >
                <div class="py-1">
                  <v-img
                    class="image-cover"
                    width="50px"
                    height="50px"
                    :src="item.image_url3"
                    alt=""
                  ></v-img>
                </div>
              </span>
            </div>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog
      v-model="dialog"
      width="fit-content"
      max-width="90dvw"
      @keydown.esc="cancel"
    >
      <v-card class="py-4 px-4">
        <image-zoom
          :regular="pic"
          :zoom-amount="4"
          :click-zoom="true"
          img-class="img-fluid-zoom"
          close-pos="top-right"
          message-pos="top"
        ></image-zoom>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TableSerialList from '@/components/TableSerialList'

export default {
  components: {
    TableSerialList,
  },

  props: {
    data: Object,
  },

  computed: {
    ...mapState({
      searchStoreDetail: (state) => state?.job?.searchStoreDetail,
      searchStoreDetailOver: (state) =>
        state?.job?.searchStoreDetailOver,
      statusStoreDetail: (state) => state?.job?.statusStoreDetail,
    }),
    currentStock() {
      const filter = this?.data?.current_stock?.filter(
        (i) =>
          i?.sku
            ?.toUpperCase()
            ?.includes(`${this.searchStoreDetail.toUpperCase()}`) ||
          i?.name
            ?.toUpperCase()
            ?.includes(`${this.searchStoreDetail.toUpperCase()}`),
      )
      return this.statusStoreDetail
        ? filter.filter(
            (i) => i.status.type === this.statusStoreDetail,
          )
        : filter
      // if (this.statusStoreDetail === 'ปกติ') {
      //   return (
      //     filter?.filter(
      //       (i) =>
      //         +i?.amount === +i?.amount_checked &&
      //         i?.amount_checked > 0,
      //     ) ?? []
      //   )
      // } else if (this.statusStoreDetail === 'สต็อกไม่ถูกต้อง') {
      //   return (
      //     filter.filter(
      //       (i) =>
      //         +i?.amount_checked < +i?.amount &&
      //         i?.amount_checked > 0,
      //     ) ?? []
      //   )
      // } else if (this.statusStoreDetail === 'สต็อกเกินจากระบบ') {
      //   return (
      //     filter.filter(
      //       (i) =>
      //         +i?.amount_checked > +i?.amount &&
      //         i?.amount_checked > 0,
      //     ) ?? []
      //   )
      // } else if (this.statusStoreDetail === 'ยังไม่ได้รับการตรวจ') {
      //   return filter.filter((i) => +i?.amount_checked === 0) ?? []
      // } else {
      //   return filter ?? []
      // }
    },
    overStock() {
      const filter = this?.data?.over_stock?.filter(
        (i) =>
          i?.product
            ?.toUpperCase()
            ?.includes(
              `${this.searchStoreDetailOver.toUpperCase()}`,
            ) ||
          i?.product_name
            ?.toUpperCase()
            ?.includes(`${this.searchStoreDetailOver.toUpperCase()}`),
      )
      return filter ?? []
    },
    tab: {
      get() {
        return this.$store.state?.job?.storeDetailTab
      },
      set(value) {
        this.$store.commit('job/SET_STORE_DETAIL_TAB', value)
      },
    },
  },

  data() {
    return {
      footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
      dialog: false,
      pic: '',
      expanded: [],
      singleExpand: false,
      items: [
        { tab: 'รายการตรวจสอบสต็อก' },
        { tab: 'รายการสินค้าสต็อกเกิน' },
      ],
      headers: [
        { text: '', value: 'data-table-expand' },
        {
          text: 'โปรดักโค้ด',
          align: 'start',
          sortable: false,
          value: 'sku',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          align: 'start',
        },
        {
          text: 'แบรนด์',
          value: 'product_brand',
          align: 'start',
        },
        {
          text: 'หมวดหมู่',
          value: 'category',
          align: 'start',
        },
        {
          text: 'หมวดหมู่ย่อย',
          value: 'sub_cat',
          align: 'start',
        },
        {
          text: 'จำนวนสต๊อก',
          value: 'amount',
          align: 'end',
        },
        {
          text: 'จำนวนตรวจเช็ค',
          value: 'amount_checked',
          align: 'end',
        },
        {
          text: 'สถานะ',
          value: 'status',
          align: 'center',
        },
        { text: 'รูปภาพ', value: 'image_url', align: 'center' },
        {
          text: 'ผู้ตรวจสอบ',
          value: 'check_by',
          align: 'start',
        },
        {
          text: 'เวลาอัพเดท',
          value: 'updated_timestamp',
          align: 'start',
        },
        {
          text: 'วันที่รับสินค้าเข้าล่าสุด',
          value: 'stock_in',
          align: 'start',
        },
      ],

      headersOverStock: [
        {
          text: 'สินค้า',
          align: 'start',
          sortable: false,
          value: 'product',
        },
        {
          text: 'ขื่อสินค้า',
          align: 'start',
          sortable: false,
          value: 'product_name',
        },
        {
          text: 'แบรนด์',
          align: 'start',
          sortable: false,
          value: 'brand',
        },
        { text: 'จำนวนสต๊อก', value: 'amount', align: 'end' },
        {
          text: 'จำนวนตรวจเช็ค',
          value: 'amount_checked',
          align: 'end',
        },
        { text: 'รูปภาพ', value: 'image_url', align: 'center' },
        {
          text: 'ผู้ตรวจสอบ',
          align: 'start',
          sortable: false,
          value: 'check_by',
        },
        {
          text: 'เวลาอัพเดท',
          value: 'updated_timestamp',
          align: 'start',
        },
      ],
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
    }
  },

  mounted() {
    this.$data.expanded = this.currentStock
  },

  methods: {
    handleClick(value) {
      this.$router.push({
        name: 'StoreDetailLog',
        params: {
          id: this.$route.params.id,
          storeId: this.$route.params.storeId,
          sku: value?.sku,
        },
      })
    },
    catchField(item, field) {
      try {
        const value = item?.[field] ?? null
        // console.log(value)
        return value
      } catch (e) {
        return field
      }
    },
    openImage(imageUrl) {
      if (imageUrl) {
        this.pic = imageUrl
        this.dialog = true
      }
    },
    getScanBarcode(val) {
      return val === 1
    },
  },
}
</script>

<style>
.image-cover {
  cursor: pointer;
  object-fit: cover;
  border-radius: 4px;
}
.v-chip-width {
  width: 140px;
  padding: 0 10px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.text-white {
  color: white;
}

.v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  box-shadow: none !important;
}
</style>

<style scoped>
/deep/ tbody tr:nth-of-type(odd) {
  background-color: #fff;
}

/deep/
  .v-data-table__expanded.v-data-table__expanded__row:nth-of-type(even) {
  background-color: red;
}

.bg-row-even {
  background-color: rgba(0, 0, 0, 0.04);
}

/deep/ .v-chip.v-size--default {
  width: 150px;
}
</style>
